import React from 'react';

import RoundedBox from 'app/shared/componentsRestyled/common/RoundedBox';
import { AutocompleteCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { formsTestIds } from '../../../../forms.testIds';

const SecurityGroupSignerConfig = ({
  form,
  validationErrors,
  securityGroupOptions,
  onAutocompleteChange,
}) => (
  <RoundedBox className="flex flex-col gap-12 min-w-[358px]">
    <AutocompleteCDS
      autoHighlight
      required
      dataTestId={formsTestIds.SECURITY_GROUP_SIGNER_SELECT}
      error={!!validationErrors.securityGroup}
      helperText={validationErrors.securityGroup}
      label="Security group (parent company)"
      name="securityGroup"
      options={securityGroupOptions}
      value={form.securityGroup}
      onChange={onAutocompleteChange}
    />
  </RoundedBox>
);

SecurityGroupSignerConfig.propTypes = {
  form: PropTypes.shape({
    securityGroup: PropTypes.object,
  }).isRequired,
  validationErrors: PropTypes.object.isRequired,
  securityGroupOptions: PropTypes.array.isRequired,
  onAutocompleteChange: PropTypes.func.isRequired,
};

export default SecurityGroupSignerConfig;
